module.exports = __webpack_public_path__ + "static/media/Javad_Hosseinzadeh.7a9e8867.jpg";